import { type ChangeEvent } from 'react';
import { twMerge } from 'tailwind-merge';

export interface TextAreaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  isReadonly?: boolean;
  max?: string;
  rows?: number;
}

function TextArea(props: TextAreaProps): JSX.Element {
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    props.onChange(event.target.value);
  };

  return (
    <textarea
      className={twMerge(
        'w-full rounded-sm border px-md py-sm text-body-sm bg-emphasis-default border-emphasis-subtle focus:outline-none',
        props.className,
      )}
      maxLength={props.max ? parseInt(props.max, 10) : undefined}
      onChange={handleChange}
      placeholder={props.placeholder}
      readOnly={props.isReadonly}
      rows={props.rows ?? 3}
      style={{ resize: 'none' }}
      value={props.value}
    />
  );
}

TextArea.displayName = 'TextArea';

export { TextArea };
